import React from 'react';
import { useSelector } from 'react-redux';
import { LinkSubmitButton } from 'Components/Fields/Buttons';
import './SignInTVProviderButton.css';

export const SignInTVProviderButton = () => {
  const routes = useSelector((s) => s.appConfig.routes);
  const handleClick = async () => {
    // trackEvent(TRACKING_ENUMS, {});
    //  await dispatch();
  };

  return <LinkSubmitButton className="providerButton" path={routes.mvpd} text="Sign in with TV Provider" />;
};
